import { ApiCore } from '@/services/api/utils/core.js'
import axios from 'axios'
import { handleResponse, handleError } from '@/services/api/utils/response.js'
import { apiProvider } from '@/services/api/utils/provider.js'

const url = `profile`
const plural = 'profiles'
const single = 'profile'

const api = new ApiCore({
	index: true,
	findOne: true,
	url: url,
	plural: plural,
	single: single
})

export default api
